import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "cneufyq";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const primaryTextCss = "pr7nx1a";
export const PrimaryText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(primaryTextCss, props.className)} />;
});
const secondaryTextCss = "s1unrabi";
export const SecondaryText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(secondaryTextCss, props.className)} />;
});
const buttonBlockCss = "bxcr0j9";
export const ButtonBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonBlockCss, props.className)} />;
});

require("./empty_state_styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./empty_state_styles.js");